import React, {useEffect, useState} from 'react'
import {Breadcrumb} from 'antd'
import {Link} from 'react-router-dom'

const BBreadcrumb = ({product}) => {
  const [route, setRoute] = useState([])

  useEffect(() => {
    if (product) {
      const tmp = []
      tmp.push({title: 'Parent category'})
      tmp.push({title: 'Child category'})
      tmp.push({to: false, title: product.name})
      setRoute(tmp)
    }
  }, [product])

  return (
    <Breadcrumb>
      <Breadcrumb.Item>
        <Link to='/'>Home</Link>
      </Breadcrumb.Item>
      {route.map(e => (
        <Breadcrumb.Item key={e.title}>
          {e.to ? <Link to={e.to}>{e.title}</Link> : e.title}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  )
}

export default BBreadcrumb
